<script setup lang="ts">
import { computed } from 'vue';

import type { AppHighlighterSize } from './AppHighlighter.model';

interface AppHighlighterProps {
  text: string;
  searchText: string;
  size?: AppHighlighterSize;
}

const props = defineProps<AppHighlighterProps>();

const highlighted = computed(() => {
  const escapedRegex = props.searchText.replace(
    /[/\-\\^$*+?.()|[\]{}]/g,
    '\\$&'
  );

  return props.text.replace(
    new RegExp(escapedRegex, 'gi'),
    (match) => `<span class="highlighted">${match}</span>`
  );
});
</script>

<template>
  <div class="app-highlighter" :class="size" v-html="highlighted" />
</template>

<style lang="scss">
@import '../../styles/_fonts.scss';
.app-highlighter {
  color: var(--color-neutral-70);
  @include font-label-m-light;
  &.small {
    @include font-label-s-light;
    .highlighted {
      @include font-label-s-bold;
    }
  }
  &.large {
    @include font-label-l-light;
    .highlighted {
      @include font-label-l-bold;
    }
  }
  .highlighted {
    @include font-label-m-bold;
  }
}
</style>
